import React from 'react';

import Footer from '../../components/Footer';
import Header from '../../components/Header';
import Video from '../../components/Video';

import soriana1 from "../../images/contents/soriana1.jpg"
import soriana2 from "../../images/contents/soriana2.jpg"

class Filmmakers extends React.Component {

  constructor (props) {
    super(props);
    this.imageClick = this.imageClick.bind(this);
  }

  imageClick(event) {
    event.preventDefault();
    let url = "https://player.vimeo.com/video/" + event.target.getAttribute('alt')
    document.getElementById('iframe').setAttribute("src", url)
    document.getElementById('video').classList.toggle("hidden")
  }

  render () {

    return (

      <React.Fragment>

        <Video id="video" />

        <div className="main maker">

          <Header />

          <div className="content">

            <h2 className="title">ACTITUD<br/>VERANO</h2>

            <div className="maker_wrapper">
              <div className="maker_container"><img key="328330954" src={soriana1} className="maker_image" video="https://vimeo.com/328330954" onClick={this.imageClick} alt="328330954"/></div>
              <div className="maker_container"><img key="328330718" src={soriana2} className="maker_image" video="https://vimeo.com/328330718" onClick={this.imageClick} alt="328330718"/></div>
              
            </div>

          </div>

          <Footer />

        </div>

      </React.Fragment>

    );
  }
}

export default Filmmakers;